export const IUpdateTipUseCaseType = Symbol('IUpdateTipUseCase');
